import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

const TrophyBadge = React.memo(
  (props: { width?: number; height?: number; containerStyle?: StyleProp<ViewStyle> }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 107}
          height={props.height ?? 130}
          viewBox="0 0 107 130"
          fill="none"
          {...props}
        >
          <G clipPath="url(#clip0_3408_48905)">
            <Path
              d="M29.1161 54.3319C28.8414 54.2526 22.2774 52.2988 11.501 43.0851C0.367593 33.5645 0.010555 17.8429 0.000255826 17.179C-0.00832683 16.6392 0.199373 16.1184 0.573577 15.7304C0.947781 15.3442 1.46102 15.1217 1.9983 15.1165L21.105 14.8906L21.1531 18.9551L4.20404 19.1552C4.68467 23.4473 6.59517 33.5542 14.1239 39.9898C24.1244 48.5413 30.1769 50.4071 30.237 50.4261L29.1161 54.3319Z"
              fill="#FCAB28"
            />
            <Path
              d="M77.8838 54.3302L76.7715 50.4226C76.8213 50.4071 82.8738 48.5395 92.876 39.9898C100.403 33.5542 102.315 23.449 102.796 19.1552L85.8468 18.9551L85.8948 14.8906L105.002 15.1165C105.539 15.1234 106.052 15.3442 106.426 15.7304C106.802 16.1167 107.008 16.6392 107 17.179C106.989 17.8429 106.634 33.5663 95.4971 43.0851C84.7225 52.2971 78.1567 54.2526 77.8821 54.3319L77.8838 54.3302Z"
              fill="#FCAB28"
            />
            <Path
              d="M20.2309 15.1199C20.2309 15.1199 17.7574 14.2163 17.7574 11.7331C17.7574 9.24989 17.3077 8.12039 19.5563 5.86137C21.805 3.60236 38.8141 0.515625 52.5258 0.515625C66.2374 0.515625 84.9699 4.28007 87.2186 6.31145C89.4672 8.34456 88.5678 13.7645 88.118 14.6663C87.6683 15.5699 85.8694 15.344 85.8694 15.344L20.2309 15.1181V15.1199Z"
              fill="#FFCF3F"
            />
            <Path
              d="M52.3767 8.11719C43.9125 8.11719 26.076 9.24669 19.5566 13.9889C19.5566 13.9889 19.5566 38.3776 26.3009 50.7987C33.0451 63.2198 44.9579 73.3819 44.9579 73.3819H61.1431C61.1431 73.3819 73.0575 63.2198 79.8 50.7987C86.5443 38.3776 86.5443 13.9889 86.5443 13.9889C79.3503 9.24669 60.8409 8.11719 52.3767 8.11719Z"
              fill="#FFD733"
            />
            <Path
              d="M52.3767 8.11719C43.9125 8.11719 26.076 9.24669 19.5566 13.9889C19.5566 13.9889 19.5566 38.3776 26.3009 50.7987C29.4954 56.6825 33.8502 62.0575 37.5493 66.0875C40.1379 67.1912 43.1126 67.8861 46.5319 67.9603C67.2127 68.4121 72.6078 50.797 74.8564 44.4752C78.3976 34.5131 80.4128 18.8708 81.2059 11.6109C72.5168 8.85007 59.1931 8.11719 52.3784 8.11719H52.3767Z"
              fill="#FFE266"
            />
            <Path
              d="M76.2031 103.867C74.1793 97.7692 69.9086 98.6728 69.9086 98.6728C69.9086 98.6728 69.9017 96.7121 66.9115 96.4311C65.0594 95.8585 60.2857 94.0169 58.6688 89.8644C56.645 84.6704 57.5444 78.121 57.5444 78.121L53.0488 77.5312L48.5532 78.121C48.5532 78.121 49.4527 84.6704 47.4289 89.8644C45.8119 94.0169 41.0383 95.8585 39.1861 96.4311C36.1959 96.7121 36.1891 98.6728 36.1891 98.6728C36.1891 98.6728 31.9183 97.7692 29.8945 103.867H76.2014H76.2031Z"
              fill="#FFCE45"
            />
            <Path
              d="M36.1914 98.6756C39.0014 98.4928 41.8113 98.3704 44.6213 98.3083C47.4313 98.2324 50.2412 98.2135 53.0512 98.2031C55.8611 98.2117 58.6711 98.2307 61.4811 98.3066C64.291 98.3687 67.101 98.4911 69.911 98.6739C67.101 98.8567 64.291 98.9809 61.4811 99.0412C58.6711 99.1154 55.8611 99.136 53.0512 99.1447C50.2412 99.136 47.4313 99.1154 44.6213 99.0395C41.8113 98.9774 39.0014 98.855 36.1914 98.6722V98.6756Z"
              fill="#FCAB28"
            />
            <Path
              d="M61.142 76.5441H45.1817C44.1879 76.5441 43.3828 75.7353 43.3828 74.7369C43.3828 73.7384 44.1879 72.9297 45.1817 72.9297H61.142C62.1359 72.9297 62.941 73.7384 62.941 74.7369C62.941 75.7353 62.1359 76.5441 61.142 76.5441Z"
              fill="#FCAB28"
            />
            <Path
              d="M60.2421 78.8246H46.0807C45.2002 78.8246 44.4844 78.1073 44.4844 77.2209C44.4844 76.3346 45.1984 75.6172 46.0807 75.6172H60.2421C61.1227 75.6172 61.8385 76.3346 61.8385 77.2209C61.8385 78.1073 61.1244 78.8246 60.2421 78.8246Z"
              fill="#FCAB28"
            />
            <Path
              d="M78.3649 103.641H29.3099C27.648 103.641 26.3008 104.994 26.3008 106.664V127.491C26.3008 129.161 27.648 130.514 29.3099 130.514H78.3649C80.0268 130.514 81.374 129.161 81.374 127.491V106.664C81.374 104.994 80.0268 103.641 78.3649 103.641Z"
              fill="#6C554F"
            />
            <Path
              d="M70.0895 108.297H37.5852C36.8154 108.297 36.1914 108.924 36.1914 109.697V121.078C36.1914 121.852 36.8154 122.479 37.5852 122.479H70.0895C70.8593 122.479 71.4833 121.852 71.4833 121.078V109.697C71.4833 108.924 70.8593 108.297 70.0895 108.297Z"
              fill="#FCAB28"
            />
            <Path
              d="M42.0648 108.297H53.2446C53.509 108.297 53.7235 108.925 53.7235 109.697V121.078C53.7235 121.851 53.509 122.479 53.2446 122.479H42.0648C41.8005 122.479 41.5859 121.851 41.5859 121.078V109.697C41.5859 108.925 41.8005 108.297 42.0648 108.297Z"
              fill="#FFD733"
            />
            <Path
              d="M44.957 73.3769C46.3062 73.2803 47.6537 73.2337 49.0029 73.1958C50.3521 73.1527 51.6996 73.1475 53.0488 73.1406C54.398 73.1458 55.7454 73.1527 57.0946 73.1941L59.1184 73.2596C59.793 73.2993 60.4676 73.3217 61.1422 73.3752C60.4676 73.4286 59.793 73.451 59.1184 73.4907L57.0946 73.5562C55.7454 73.5993 54.398 73.6045 53.0488 73.6097C51.6996 73.6045 50.3521 73.5976 49.0029 73.5545C47.6537 73.5166 46.3062 73.4717 44.957 73.3734V73.3769Z"
              fill="#FFE266"
            />
            <Path
              d="M45.0332 76.0956C46.4064 75.9991 47.7814 75.9525 49.1546 75.9146C50.5278 75.8714 51.9028 75.8645 53.276 75.8594C54.6492 75.8645 56.0242 75.8714 57.3974 75.9128L59.4572 75.9784C60.1438 76.018 60.8304 76.0404 61.5171 76.0939C60.8304 76.1474 60.1438 76.1698 59.4572 76.2094L57.3974 76.275C56.0242 76.3181 54.6492 76.3232 53.276 76.3284C51.9028 76.3232 50.5278 76.3163 49.1546 76.2732C47.7814 76.2353 46.4064 76.1905 45.0332 76.0922V76.0956Z"
              fill="#FFE266"
            />
            <Path
              d="M48.7109 79.1034C50.158 78.9189 51.6033 78.8758 53.0503 78.8672C54.4974 78.8741 55.9427 78.9155 57.3897 79.1034C55.9427 79.2897 54.4974 79.3328 53.0503 79.3397C51.6033 79.3328 50.158 79.2897 48.7109 79.1034Z"
              fill="#FFE266"
            />
            <Path
              d="M30.8711 101.683C34.5668 101.501 38.2642 101.378 41.9616 101.316C45.6573 101.24 49.3547 101.221 53.0504 101.211C56.7461 101.22 60.4435 101.239 64.1409 101.314C67.8366 101.376 71.534 101.499 75.2314 101.682C71.534 101.864 67.8383 101.989 64.1409 102.049C60.4435 102.123 56.7478 102.144 53.0504 102.152C49.353 102.144 45.6573 102.123 41.9616 102.047C38.2642 101.985 34.5685 101.863 30.8711 101.68V101.683Z"
              fill="#FCAB28"
            />
            <G opacity="0.48">
              <Path
                d="M41.0165 1.125C37.2402 1.49403 33.5788 2.00619 30.3706 2.58905C29.9981 13.741 29.8814 32.3752 32.5952 42.677C36.6411 58.0331 43.8351 65.712 43.8351 65.712C43.8351 65.712 39.3395 43.1288 39.7892 23.2564C40.0038 13.7392 40.529 6.30175 41.0165 1.12672V1.125Z"
                fill="#FFFFFD"
              />
            </G>
            <Path
              d="M86.5443 13.9954C84.0536 12.5641 81.2934 11.745 78.5212 11.1087C75.7439 10.4689 72.9236 10.0223 70.0931 9.67566C67.2608 9.34284 64.4182 9.079 61.5705 8.90828C58.7227 8.73067 55.8699 8.61341 53.0204 8.60134C50.1727 8.57374 47.3198 8.67204 44.4721 8.83069C41.6227 8.97899 38.7801 9.23248 35.9478 9.56185C33.119 9.90673 30.2953 10.3378 27.5213 10.9862C24.7543 11.6312 21.9907 12.4658 19.5566 13.9954C20.7222 13.1659 21.9821 12.4382 23.3261 11.926C23.6592 11.7915 23.9887 11.645 24.3269 11.5191L25.3482 11.1707C26.0262 10.9259 26.718 10.7293 27.4098 10.5362C30.1837 9.77568 33.0143 9.24283 35.8551 8.83069C41.5437 8.01848 47.2803 7.64945 53.029 7.65634C58.7725 7.72187 64.5075 8.12539 70.1926 8.94622C73.0335 9.36009 75.8606 9.90846 78.6345 10.6603C79.3314 10.8345 80.0146 11.0638 80.6978 11.2846C81.3861 11.488 82.0556 11.7571 82.725 12.0192C83.403 12.2571 84.0433 12.5934 84.6922 12.9004C85.0217 13.0452 85.3273 13.2366 85.6311 13.428L86.546 13.9936L86.5443 13.9954Z"
              fill="#FCAB28"
            />
            <Path
              d="M38.3852 18.9298L40.4845 15.2344L42.4499 19.004L46.1284 21.113L42.3761 23.0875L40.2768 26.7829L38.3113 23.0133L34.6328 20.9043L38.3852 18.9298Z"
              fill="white"
            />
            <G opacity="0.35">
              <Path
                d="M31.6406 130.514H39.971L60.777 103.641H51.2039L31.6406 130.514Z"
                fill="white"
              />
            </G>
            <G opacity="0.35">
              <Path
                d="M52.2086 130.514L72.843 103.641H68.931L48.082 130.514H52.2086Z"
                fill="white"
              />
            </G>
          </G>
          <Defs>
            <ClipPath id="clip0_3408_48905">
              <Rect width="107" height="130" fill="white" transform="translate(0 0.515625)" />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { TrophyBadge };
